import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

class ForumSearch extends WebComponent {
  constructor(props) {
    super(props);
    this.handleInput = this.handleInput.bind(this);
  }

  didMount() {
    const self = this;
    this.searchPost = this.element.querySelector('#searchPost');
    this.reset = this.element.querySelector('#reset');
    this.submit = this.element.querySelector('#searchPostSubmit');

    this.handleInput(this.searchPost);

    this.searchPost.addEventListener('keyup', function(e) {
      self.handleInput(self.searchPost);
    });

    this.reset.addEventListener('click', function(e) {
      self.searchPost.value = '';
      self.submit.click();
    });
  }

  handleInput(el) {
    if (el.value !== '') {
      this.element.classList.add('form--active');
    } else {
      this.element.classList.remove('form--active');
    }
  }
}

export default ForumSearch;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ForumSearch.js